import React from 'react';
import { Star, CheckCircle2, Heart, Sparkles } from 'lucide-react';
import { CUSTOMER_REVIEWS } from '../data/products';

export const ReviewsSection: React.FC = () => {
  return (
    <section id="reviews" className="py-16 md:py-24 bg-[#FCFAF8] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-14 space-y-3">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#FEF08A] text-[#854D0E] text-xs font-bold uppercase tracking-wider border border-[#FDE047]">
            <Star className="w-3.5 h-3.5 fill-[#D97706] text-[#D97706]" />
            <span>Verified Customer Love</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#292524]">
            Loved by Gymnasts, Students & Nail Enthusiasts
          </h2>
          <div className="flex items-center justify-center gap-2 pt-1 text-sm font-semibold text-[#44403C]">
            <div className="flex text-[#F59E0B]">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-[#F59E0B]" />
              ))}
            </div>
            <span>4.95 / 5.0 Average Customer Rating</span>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {CUSTOMER_REVIEWS.map((review) => (
            <div
              key={review.id}
              className="p-6 rounded-3xl bg-white border border-[#EADFCF] shadow-xs hover:shadow-lg transition-all flex flex-col justify-between space-y-4 group hover:border-[#D4AF37]/60"
            >
              <div className="space-y-3">
                {/* Rating Stars & Verified Badge */}
                <div className="flex items-center justify-between">
                  <div className="flex text-[#F59E0B]">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} className="w-3.5 h-3.5 fill-[#F59E0B]" />
                    ))}
                  </div>
                  {review.verified && (
                    <span className="flex items-center gap-1 text-[10px] font-bold text-[#10B981] bg-[#D1FAE5] px-2 py-0.5 rounded-full">
                      <CheckCircle2 className="w-3 h-3" />
                      Verified
                    </span>
                  )}
                </div>

                {/* Comment */}
                <p className="text-xs text-[#57534E] leading-relaxed italic">
                  "{review.comment}"
                </p>
              </div>

              <div className="pt-3 border-t border-[#F5EBE0] space-y-1">
                <div className="flex items-center justify-between text-xs">
                  <strong className="font-bold text-[#292524]">{review.name}</strong>
                  <span className="text-[11px] text-[#A8A29E]">{review.location}</span>
                </div>
                <div className="flex items-center justify-between text-[11px]">
                  <span className="text-[#854D0E] font-medium">{review.productName}</span>
                  <span className="text-[#A8A29E] text-[10px]">{review.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
